export default __webpack_public_path__ + "static/media/shower-icon.b37e426d.svg";